import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type freeToStandardModalQuery,
	type JiraApplicationKey,
	type JiraProjectType,
} from './__generated__/freeToStandardModalQuery.graphql';

export type EntryPointParams = {
	cloudId: string;
	isConfluence: boolean;
	isJira: boolean;
	jiraApplicationKey: JiraApplicationKey;
	projectType: JiraProjectType;
	shouldIncludeGUPS: boolean;
};

export const entryPoint: EntryPoint<
	EntryPointComponent<
		{
			freeToStandardModalQuery: freeToStandardModalQuery;
		},
		Record<string, never>,
		{
			onClose: () => void;
		},
		Record<string, never>
	>,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-free-to-standard-modal" */ './free-to-standard-modal'
			),
		{
			moduleId: 'edition-awareness-free-to-standard-modal',
		},
	),
	getPreloadProps: ({
		cloudId,
		projectType,
		jiraApplicationKey,
		isJira,
		isConfluence,
		shouldIncludeGUPS,
	}: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			freeToStandardModalQuery: {
				parameters,
				variables: {
					cloudId,
					jiraApplicationKey,
					projectType,
					isJira,
					isConfluence,
					shouldIncludeGUPS,
				},
			},
		},
	}),
});
